module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graveyard_id),
      expression: "graveyard_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.graveyard_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Alle Friedhöfe")]), _vm._v(" "), _vm._l((_vm.$store.getters.models('graveyards')), function(graveyard) {
    return _c('option', {
      domProps: {
        "value": graveyard.id
      }
    }, [_vm._v(_vm._s(graveyard.name))])
  })], 2), _vm._v(" "), _c('br')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d1af036!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graveyard-select.vue
// module id = 426
// module chunks = 0